import { Button, Text } from 'components/ui';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';
import { globalTheme } from '../../styles/global-theme';

const Wrapper = styled.div`
  background-color: ${globalTheme.colors.neutralLight};
  padding: 30px 182px 0 182px;
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: ${breakpoints.large}) {
    flex-direction: column;
    margin: auto;
    justify-content: center;
    padding: ${globalTheme.space[2]};
  }
`;

const Title = styled.div`
  padding-bottom: 30px;
`;

const FindMoreBtn = styled(Button)`
  margin: 25px 0;
`;

const LeftSection = styled.div`
  flex-basis: 32%;
  @media screen and (max-width: ${breakpoints.large}) {
    flex-basis: 42%;
    display: flex;
    flex-direction: column;
    margin: 30px 0;
  }
`;

const BtnGroup = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;

  @media screen and (max-width: ${breakpoints.small}) {
    flex-direction: column;
  }
`;

const DownloanBtn = styled.img`
  width: 204px;
  height: 63px;
  margin-right: 15px;
  cursor: pointer;
  @media screen and (max-width: ${breakpoints.small}) {
    width: 180px;
    height: 63px;
  }
`;

const RightSection = styled.div`
  height: 380px;
  overflow: hidden;
  align-self: end;
  @media screen and (max-width: ${breakpoints.large}) {
    transform: none;
    display: flex;
    justify-content: center;
    align-self: center;
  }
  @media screen and (max-width: ${breakpoints.small}) {
    transform: translateY(20px);

    & > img {
      width: 100%;
      height: 100%;
    }
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
`;

function AgoraAdvertisement() {
  const router = useRouter();

  return (
    <Wrapper>
      <LeftSection>
        <Title>
          <div>
            <Text as='span' fontWeight='bold' color='pink' fontSize={6}>
              Offer with ease
            </Text>
            <Text as='span' color='darkBlue' fontWeight='bold' fontSize={6}>
              {' '}
              using
            </Text>
          </div>
          <div>
            <Text as='span' color='darkBlue' fontWeight='bold' fontSize={6}>
              Agora Livestock
            </Text>
            <Text as='span' fontWeight='bold' color='pink' fontSize={6}>
              .
            </Text>
          </div>
        </Title>
        <div>
          <Text as='span' fontWeight='semiBold' fontSize={4}>
            Have you got livestock to sell?{' '}
          </Text>
          <Text as='span' fontSize={4}>
            Join thousands of Australian buyers, sellers and agents using Agora
            Livestock to maximise their markets.
          </Text>
        </div>
        <ButtonWrapper>
          <FindMoreBtn
            size='medium'
            href='https://agoralivestock.com.au/about-marketplace'
            target='_blank'
            rel='noopener noreferrer'
          >
            Find out more
          </FindMoreBtn>
        </ButtonWrapper>
        <BtnGroup>
          <Link
            href='https://apps.apple.com/au/app/agora-livestock-markets/id1560791647'
            legacyBehavior
          >
            <DownloanBtn src='/images/app-store-badge.svg' />
          </Link>

          <Link
            href='https://play.google.com/store/apps/details?id=au.com.livestockpricing.seller&hl=en&gl=US'
            legacyBehavior
          >
            <DownloanBtn src='/images/google-play-badge.svg' />
          </Link>
        </BtnGroup>
      </LeftSection>
      <RightSection>
        <img src='/images/agora-hand-phone.png' width={300} height={380} />
      </RightSection>
    </Wrapper>
  );
}

export default AgoraAdvertisement;
